import { render, staticRenderFns } from "./lengOverview.vue?vue&type=template&id=38dae890&scoped=true&"
import script from "./lengOverview.vue?vue&type=script&lang=js&"
export * from "./lengOverview.vue?vue&type=script&lang=js&"
import style0 from "./lengOverview.vue?vue&type=style&index=0&id=38dae890&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38dae890",
  null
  
)

export default component.exports